import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { ReactNode } from "react";
type DividerProps = {
  containerStyles?: string;
  children: ReactNode;
};
export default function Divider(t0) {
  const $ = _c(7);
  const {
    containerStyles,
    children
  } = t0;
  let t1;
  if ($[0] !== containerStyles) {
    t1 = cn("grid grid-cols-[1fr,auto,1fr] items-center gap-4 py-2", containerStyles);
    $[0] = containerStyles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-0.5 bg-muted" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-0.5 bg-muted" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t1) {
    t4 = <div className={t1}>{t2}{children}{t3}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}